import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const exportToExcelPending = async (data) => {
    const excelSampleData = data.sampleData;
    const excelCustomerData = data.formData;
    const isMetric = false; // TODO future
    const fileExtension = '.xlsx';

    const currentDate = new Date().toDateString();
    let lastRowIndex = 4; // Index should start from 4th row since the first 3 is used for headers
    try {
        // Create a workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Report');

        // Define keys to skip
        const newLine =['product']
        const uValueKeySummer = isMetric ? 'u_value_summer_metric' : 'u_value_summer';
        const uValueKeyWinter = isMetric ? 'u_value_solar_metric' : 'u_value_solar';
        const keys = ['product', 'sampleSize', 'quantity', 'drawing', 'note', 'description_visible', 'reflectance_out', uValueKeySummer, uValueKeyWinter, 'shading_coefficient', 'solar_heat_gain_coefficient', 'light_solar_gain_ration'];
        const customerKeys = ['contactName', 'contactEmail', 'shipmentDestination', 'shipmentAddress', 'shipmentAddress2', 'shipmentCity', 'shipmentState', 'shipmentPostcode', 'shipmentCountry', 'ownerName'];

        // Create a new array without the undesired keys
        const newArray = excelSampleData.map(item => {
            const newItem = {};
            Object.keys(item).forEach(key => {
                if (keys.includes(key)) {
                    newItem[key] = item[key];

                }
                if (newLine.includes(key)) {
                    newItem[key] = `${item.top_line_imp}\n${item.spec_imp.join('\n')}`
                }
            });
            return newItem;
        }).filter(item => item !== null);

        // TODO horizontal might be center as well
        const generalStyle = {
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffdbe4f3' }},
            alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
            border: {
                top: {style:'medium', color: {argb:'FFFFFFFF'}},
                left: {style:'medium', color: {argb:'FFFFFFFF'}},
                bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                right: {style:'medium', color: {argb:'FFFFFFFF'}}
            },
            font: { name: 'Calibri', size: 13 }
        }

        const titleStyle = {
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEEEEEE' }},
            alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
            border: {
                top: {style:'medium', color: {argb:'FFFFFFFF'}},
                left: {style:'medium', color: {argb:'FFFFFFFF'}},
                bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                right: {style:'medium', color: {argb:'FFFFFFFF'}}
            },
            font: { name: 'Calibri', size: 13, bold: true }
        }

        for (let i = 0; i < newArray.length; i+= 1) {
            const rowData = newArray[i];
            const row = worksheet.getRow(i + 2); // just to start from the second row
            row.height = 150;
            // Set values for each cell in the row
            let finalKeyIndex = 0;

            keys.forEach((key, index) => {
                row.getCell(index + 1).value = rowData[key];
                row.getCell(index + 1).style = generalStyle;
                finalKeyIndex = index;
            });

            finalKeyIndex+=1;

            for(let k = 0 ; k < customerKeys.length ; k+= 1) {
                row.getCell(finalKeyIndex + 1).value = excelCustomerData[customerKeys[k]];
                row.getCell(finalKeyIndex + 1).style = generalStyle;
                finalKeyIndex+= 1;
            }

            lastRowIndex+=1;
        }

        const columnA = worksheet.getColumn('A');
        const columnB = worksheet.getColumn('B');
        const columnC = worksheet.getColumn('C');
        const columnD = worksheet.getColumn('D');
        const columnE = worksheet.getColumn('E');
        const columnF = worksheet.getColumn('F');
        const columnG = worksheet.getColumn('G');
        const columnH = worksheet.getColumn('H');
        const columnI = worksheet.getColumn('I');
        const columnJ = worksheet.getColumn('J');
        const columnK = worksheet.getColumn('K');
        const columnL = worksheet.getColumn('L');
        const columnM = worksheet.getColumn('M');
        const columnN = worksheet.getColumn('N');
        const columnO = worksheet.getColumn('O');
        const columnP = worksheet.getColumn('P');
        const columnQ = worksheet.getColumn('Q');
        const columnR = worksheet.getColumn('R');
        const columnS = worksheet.getColumn('S');
        const columnT = worksheet.getColumn('T');
        const columnU = worksheet.getColumn('U');
        const columnV = worksheet.getColumn('V');
        columnA.width = 40;
        columnB.width = 40;
        columnC.width = 40;
        columnD.width = 40;
        columnE.width = 40;
        columnF.width = 40;
        columnG.width = 40;
        columnH.width = 40;
        columnI.width = 40;
        columnJ.width = 40;
        columnK.width = 40;
        columnL.width = 40;
        columnM.width = 40;
        columnN.width = 40;
        columnO.width = 40;
        columnP.width = 40;
        columnQ.width = 40;
        columnR.width = 40;
        columnS.width = 40;
        columnT.width = 40;
        columnU.width = 40;
        columnV.width = 40;

        const row1 = worksheet.getRow(1);
        row1.height = 20;

        worksheet.getCell('A1').value = 'Product';
        worksheet.getCell('B1').value = 'Sample Size';
        worksheet.getCell('C1').value = 'Quantity';
        worksheet.getCell('D1').value = 'Drawing';
        worksheet.getCell('E1').value = 'Note';
        worksheet.getCell('F1').value = 'VLT';
        worksheet.getCell('G1').value = 'R OUT';
        worksheet.getCell('H1').value = 'Summmer U';
        worksheet.getCell('I1').value = 'Winter U';
        worksheet.getCell('J1').value = 'SC';
        worksheet.getCell('K1').value = 'SHGC';
        worksheet.getCell('L1').value = 'LSG';
        worksheet.getCell('M1').value = 'Contact Name';
        worksheet.getCell('N1').value = 'Contact Email';
        worksheet.getCell('O1').value = 'Shipment Destination';
        worksheet.getCell('P1').value = 'Shipment Address 1';
        worksheet.getCell('Q1').value = 'Shipment Address 2';
        worksheet.getCell('R1').value = 'Shipment City';
        worksheet.getCell('S1').value = 'Shipment State';
        worksheet.getCell('T1').value = 'Shipment Postcode';
        worksheet.getCell('U1').value = 'Shipment Country';
        worksheet.getCell('V1').value = 'Created By';

        worksheet.getCell('A1').style = titleStyle;
        worksheet.getCell('B1').style = titleStyle;
        worksheet.getCell('C1').style = titleStyle;
        worksheet.getCell('D1').style = titleStyle;
        worksheet.getCell('E1').style = titleStyle;
        worksheet.getCell('F1').style = titleStyle;
        worksheet.getCell('G1').style = titleStyle;
        worksheet.getCell('H1').style = titleStyle;
        worksheet.getCell('I1').style = titleStyle;
        worksheet.getCell('J1').style = titleStyle;
        worksheet.getCell('K1').style = titleStyle;
        worksheet.getCell('L1').style = titleStyle;
        worksheet.getCell('M1').style = titleStyle;
        worksheet.getCell('N1').style = titleStyle;
        worksheet.getCell('O1').style = titleStyle;
        worksheet.getCell('P1').style = titleStyle;
        worksheet.getCell('Q1').style = titleStyle;
        worksheet.getCell('R1').style = titleStyle;
        worksheet.getCell('S1').style = titleStyle;
        worksheet.getCell('T1').style = titleStyle;
        worksheet.getCell('U1').style = titleStyle;
        worksheet.getCell('V1').style = titleStyle;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const filename = `${data.formData.customerName}_${data.formData.projectName}_${currentDate}_${fileExtension}`;
        FileSaver.saveAs(blob, filename);
    } catch (error) {
        console.error('Error exporting to Excel:', error);
    }
};

export const boxLabelDataExcelExport = async (data, lineValues, boxValues) => {
    const excelCustomerData = data.formData;
    const currentDate = new Date().toDateString();

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('BoxLabel');

        const generalStyle = {
            fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'ffdbe4f3' }
            },
            alignment: {
                horizontal: 'center',
                vertical: 'middle',
                wrapText: true
            },
            border: {
                top: { style: 'medium', color: { argb: 'FFFFFFFF' } },
                left: { style: 'medium', color: { argb: 'FFFFFFFF' } },
                bottom: { style: 'medium', color: { argb: 'FFFFFFFF' } },
                right: { style: 'medium', color: { argb: 'FFFFFFFF' } }
            },
            font: {
                name: 'Calibri',
                size: 13
            }
        };

        const titleStyle = {
            fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFEEEEEE' }
            },
            alignment: {
                horizontal: 'center',
                vertical: 'middle',
                wrapText: true
            },
            border: {
                top: { style: 'medium', color: { argb: 'FFFFFFFF' } },
                left: { style: 'medium', color: { argb: 'FFFFFFFF' } },
                bottom: { style: 'medium', color: { argb: 'FFFFFFFF' } },
                right: { style: 'medium', color: { argb: 'FFFFFFFF' } }
            },
            font: {
                name: 'Calibri',
                size: 13,
                bold: true
            }
        };

        worksheet.getRow(1).height = 20;

        worksheet.getCell('A1').value = 'Customer Name';
        worksheet.getCell('B1').value = 'Project Name';
        worksheet.getCell('C1').value = 'Order Number';
        worksheet.getCell('D1').value = 'Line Number';

        worksheet.getCell('A1').style = titleStyle;
        worksheet.getCell('B1').style = titleStyle;
        worksheet.getCell('C1').style = titleStyle;
        worksheet.getCell('D1').style = titleStyle;

        // Column widths
        ['A', 'B', 'C', 'D'].forEach(col => {
            worksheet.getColumn(col).width = 40;
        });

        let rowIndex = 2;

        const length = Math.min(lineValues.length, boxValues.length);

        for (let i = 0; i < length; i += 1) {
            const repeatCount = Number(boxValues[i]) || 0;

            for (let j = 0; j < repeatCount; j += 1) {
                const row = worksheet.getRow(rowIndex);
                row.height = 150;

                row.getCell(1).value = excelCustomerData.customerName;
                row.getCell(2).value = excelCustomerData.projectName;
                row.getCell(3).value = data.orderId;
                row.getCell(4).value = lineValues[i];

                row.getCell(1).style = generalStyle;
                row.getCell(2).style = generalStyle;
                row.getCell(3).style = generalStyle;
                row.getCell(4).style = generalStyle;

                rowIndex += 1;
            }
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const filename =
            `BoxLabel_SA${data.orderId}${data.isRevised ? 'R' : ''}_` +
            `${excelCustomerData.customerName}_${excelCustomerData.projectName}_` +
            `${currentDate}.xlsx`;

        FileSaver.saveAs(blob, filename);

    } catch (error) {
        console.error('Error exporting to Excel:', error);
    }
};

export const glassLabelDataExcelExport = async (data, lineValues) => {
    const excelSampleData = [];
    const excelLineValues = [];

    data.sampleData.forEach((item, index) => {
        for(let i = 0 ; i < Number(item.quantity) ; i += 1 ) {
            excelSampleData.push(item);
            excelLineValues.push(lineValues[index]);
        }
    })

    const excelCustomerData = data.formData;
    const isMetric = false; // TODO future
    const fileExtension = '.xlsx';

    const currentDate = new Date().toDateString();
    let lastRowIndex = 4; // Index should start from 4th row since the first 3 is used for headers
    try {
        // Create a workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Report');

        // Define keys to skip
        const newLine =['product']
        const uValueKeySummer = isMetric ? 'u_value_summer_metric' : 'u_value_summer';
        const uValueKeyWinter = isMetric ? 'u_value_solar_metric' : 'u_value_solar';
        const keys = ['product', 'family', 'quantity', 'drawing', 'note', 'description_visible', 'reflectance_out', uValueKeySummer, uValueKeyWinter, 'shading_coefficient', 'solar_heat_gain_coefficient', 'light_solar_gain_ration'];
        const customerKeys = ['customerName', 'projectName'];

        // Create a new array without the undesired keys
        const newArray = excelSampleData.map(item => {
            const newItem = {};
            Object.keys(item).forEach(key => {
                if (keys.includes(key)) {
                    newItem[key] = item[key];

                }
                if (newLine.includes(key)) {
                    newItem[key] = `${item.top_line_imp}\n${item.spec_imp.join('\n')}`
                }
            });
            return newItem;
        }).filter(item => item !== null);

        // TODO horizontal might be center as well
        const generalStyle = {
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'ffdbe4f3' }},
            alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
            border: {
                top: {style:'medium', color: {argb:'FFFFFFFF'}},
                left: {style:'medium', color: {argb:'FFFFFFFF'}},
                bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                right: {style:'medium', color: {argb:'FFFFFFFF'}}
            },
            font: { name: 'Calibri', size: 13 }
        }

        const titleStyle = {
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEEEEEE' }},
            alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
            border: {
                top: {style:'medium', color: {argb:'FFFFFFFF'}},
                left: {style:'medium', color: {argb:'FFFFFFFF'}},
                bottom: {style:'medium', color: {argb:'FFFFFFFF'}},
                right: {style:'medium', color: {argb:'FFFFFFFF'}}
            },
            font: { name: 'Calibri', size: 13, bold: true }
        }

        for (let i = 0; i < newArray.length; i+= 1) {
            const rowData = newArray[i];
            const row = worksheet.getRow(i + 2); // just to start from the second row
            row.height = 150;
            // Set values for each cell in the row
            let finalKeyIndex = 0;

            keys.forEach((key, index) => {
                row.getCell(index + 1).value = (rowData[key] !== 'N/A' && rowData[key] !==0) ? rowData[key] : '';
                row.getCell(index + 1).style = generalStyle;
                finalKeyIndex = index;
            });

            finalKeyIndex+=1;

            for(let k = 0 ; k < customerKeys.length ; k+= 1) {
                row.getCell(finalKeyIndex + 1).value = excelCustomerData[customerKeys[k]];
                row.getCell(finalKeyIndex + 1).style = generalStyle;
                finalKeyIndex+= 1;
            }

            row.getCell(finalKeyIndex + 1).value = excelSampleData[i].top_line_imp;
            row.getCell(finalKeyIndex + 1).style = generalStyle;
            finalKeyIndex+= 1;

            for(let j = 0 ; j < excelSampleData[i].spec_imp.length ; j+= 1) {
                row.getCell(finalKeyIndex + 1).value = excelSampleData[i].spec_imp[j];
                row.getCell(finalKeyIndex + 1).style = generalStyle;
                finalKeyIndex+= 1;
            }

            row.getCell('AD').value = data.orderId;
            row.getCell('AD').style = generalStyle;
            finalKeyIndex+= 1;

            row.getCell('AE').value = excelLineValues[i];
            row.getCell('AE').style = generalStyle;
            finalKeyIndex+= 1;

            lastRowIndex+=1;
        }

        const columnA = worksheet.getColumn('A');
        const columnB = worksheet.getColumn('B');
        const columnC = worksheet.getColumn('C');
        const columnD = worksheet.getColumn('D');
        const columnE = worksheet.getColumn('E');
        const columnF = worksheet.getColumn('F');
        const columnG = worksheet.getColumn('G');
        const columnH = worksheet.getColumn('H');
        const columnI = worksheet.getColumn('I');
        const columnJ = worksheet.getColumn('J');
        const columnK = worksheet.getColumn('K');
        const columnL = worksheet.getColumn('L');
        const columnM = worksheet.getColumn('M');
        const columnN = worksheet.getColumn('N');
        const columnO = worksheet.getColumn('O');
        const columnP = worksheet.getColumn('P');
        const columnQ = worksheet.getColumn('Q');
        const columnR = worksheet.getColumn('R');
        const columnS = worksheet.getColumn('S');
        const columnT = worksheet.getColumn('T');
        const columnU = worksheet.getColumn('U');
        const columnV = worksheet.getColumn('V');
        const columnW = worksheet.getColumn('W');
        const columnX = worksheet.getColumn('X');
        const columnY = worksheet.getColumn('Y');
        const columnZ = worksheet.getColumn('Z');
        const columnAA = worksheet.getColumn('AA');
        const columnAB = worksheet.getColumn('AB');
        const columnAC = worksheet.getColumn('AC');
        const columnAD = worksheet.getColumn('AD');
        const columnAE = worksheet.getColumn('AE');
        columnA.width = 40;
        columnB.width = 40;
        columnC.width = 40;
        columnD.width = 40;
        columnE.width = 40;
        columnF.width = 40;
        columnG.width = 40;
        columnH.width = 40;
        columnI.width = 40;
        columnJ.width = 40;
        columnK.width = 40;
        columnL.width = 40;
        columnM.width = 40;
        columnN.width = 40;
        columnO.width = 40;
        columnP.width = 40;
        columnQ.width = 40;
        columnR.width = 40;
        columnS.width = 40;
        columnT.width = 40;
        columnU.width = 40;
        columnV.width = 40;
        columnW.width = 40;
        columnX.width = 40;
        columnY.width = 40;
        columnZ.width = 40;
        columnAA.width = 40;
        columnAB.width = 40;
        columnAC.width = 40;
        columnAD.width = 40;
        columnAE.width = 40;

        const row1 = worksheet.getRow(1);
        row1.height = 20;

        worksheet.getCell('A1').value = 'Product';
        worksheet.getCell('B1').value = 'Glass Type';
        worksheet.getCell('C1').value = 'Quantity';
        worksheet.getCell('D1').value = 'Drawing';
        worksheet.getCell('E1').value = 'Note';
        worksheet.getCell('F1').value = 'VLT';
        worksheet.getCell('G1').value = 'R OUT';
        worksheet.getCell('H1').value = 'Summmer U';
        worksheet.getCell('I1').value = 'Winter U';
        worksheet.getCell('J1').value = 'SC';
        worksheet.getCell('K1').value = 'SHGC';
        worksheet.getCell('L1').value = 'LSG';
        worksheet.getCell('M1').value = 'Customer Name';
        worksheet.getCell('N1').value = 'Project Name';
        worksheet.getCell('O1').value = 'General Description';
        worksheet.getCell('P1').value = 'Description 1';
        worksheet.getCell('Q1').value = 'Description 2';
        worksheet.getCell('R1').value = 'Description 3';
        worksheet.getCell('S1').value = 'Description 4';
        worksheet.getCell('T1').value = 'Description 5';
        worksheet.getCell('U1').value = 'Description 6';
        worksheet.getCell('V1').value = 'Description 7';
        worksheet.getCell('W1').value = 'Description 8';
        worksheet.getCell('X1').value = 'Description 9';
        worksheet.getCell('Y1').value = 'Description 10';
        worksheet.getCell('Z1').value = 'Description 11';
        worksheet.getCell('AA1').value = 'Description 12';
        worksheet.getCell('AB1').value = 'Description 13';
        worksheet.getCell('AC1').value = 'Description 14';
        worksheet.getCell('AD1').value = 'Order Number';
        worksheet.getCell('AE1').value = 'Line Number';

        worksheet.getCell('A1').style = titleStyle;
        worksheet.getCell('B1').style = titleStyle;
        worksheet.getCell('C1').style = titleStyle;
        worksheet.getCell('D1').style = titleStyle;
        worksheet.getCell('E1').style = titleStyle;
        worksheet.getCell('F1').style = titleStyle;
        worksheet.getCell('G1').style = titleStyle;
        worksheet.getCell('H1').style = titleStyle;
        worksheet.getCell('I1').style = titleStyle;
        worksheet.getCell('J1').style = titleStyle;
        worksheet.getCell('K1').style = titleStyle;
        worksheet.getCell('L1').style = titleStyle;
        worksheet.getCell('M1').style = titleStyle;
        worksheet.getCell('N1').style = titleStyle;
        worksheet.getCell('O1').style = titleStyle;
        worksheet.getCell('P1').style = titleStyle;
        worksheet.getCell('Q1').style = titleStyle;
        worksheet.getCell('R1').style = titleStyle;
        worksheet.getCell('S1').style = titleStyle;
        worksheet.getCell('T1').style = titleStyle;
        worksheet.getCell('U1').style = titleStyle;
        worksheet.getCell('V1').style = titleStyle;
        worksheet.getCell('W1').style = titleStyle;
        worksheet.getCell('X1').style = titleStyle;
        worksheet.getCell('Y1').style = titleStyle;
        worksheet.getCell('Z1').style = titleStyle;
        worksheet.getCell('AA1').style = titleStyle;
        worksheet.getCell('AB1').style = titleStyle;
        worksheet.getCell('AC1').style = titleStyle;
        worksheet.getCell('AD1').style = titleStyle;
        worksheet.getCell('AE1').style = titleStyle;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const filename = `GlassLabel_SA${data.orderId}${data.isRevised ? 'R' : ''}_${data.formData.customerName}_${data.formData.projectName}_${currentDate}_${fileExtension}`;
        FileSaver.saveAs(blob, filename);
    } catch (error) {
        console.error('Error exporting to Excel:', error);
    }
};